import styled from "styled-components";
import { theme } from "../../styles/theme";
import { pagePaddingX } from "../../styles/layout";

export const StyledContainer = styled("div")<{
  border?: boolean;
}>`
  position: relative;
  width: 100%;
  max-width: calc(${theme.layout.maxWidth} + ${theme.layout.paddingX} * 2);
  margin-right: auto;
  margin-left: auto;
  ${pagePaddingX}
  border-top: ${(p) => (p.border ? `1px solid ${theme.colors.border}` : "")};
`;
